(function () {
  'use strict';

  angular.module('app').directive('exitPopup', function ($http, $compile, $timeout, localStorageService, GTM) {
    return {
      restrict: 'A',
      scope: {
        products: '=',
        step: '=',
        shop: '=',
        stepToOpen: '=',
        roomParams: '=',
        trip: '=',
        pageUrl: '=',
        inclusions: '=',
        resortCheckout: '=',
        roomTitle: '=',
        numberOfGuests: '=',
        isLastMinute: '=',
      },
      controller: 'exitPopupCtrl',
      controllerAs: '$ctrl',
      link: link,
    };

    function link(scope) {
      var template,
        html,
        availability;

      $http.get('templates/_checkout-exit-popup.html').then(function (response) {
        html = response.data;
      });

      $(document).on('mouseleave', function (e) {
        if (e.clientY < 0 && scope.step === scope.stepToOpen && !$.fancybox.isActive && !localStorageService.get('exitPopup')) {
          scope.items = [].concat(scope.inclusions);

          _.each(scope.products, function (v) {
            if (v.room.itemAvailability < 5) {
              availability = true;
            }

            _.each(v.pricing, function (val) {
              scope.items.push({pricing: val.id, quantity: val.qty});
            });
          });

          if (!scope.isLastMinute && (availability || scope.resortCheckout)) {
            $timeout(function () {
              template = $compile(angular.element(html))(scope);

              showPopup(template);
              availability = false;
            });
          }
        }
      });

      function showPopup() {
        jQuery.fancybox({
          content: template,
          type: 'html',
          padding: 40,
          wrapCSS: 'checkout-exit-popup',
          maxWidth: '1000',
          openEffect: 'elastic',
          beforeShow: function () {},
          afterClose: function () {
            localStorageService.set('exitPopup', true);
          },
          afterShow: function () {
            GTM.event('booking_enquiry_reserve_spot_start');
          }
        });
      }
    }
  });

  angular.module('app').controller('exitPopupCtrl', function ($scope, checkoutService, $location, $rootScope, Auth, GTM, utils, gettextCatalog) {
    var vm = this;

    vm.submit = submit;

    function submit(form) {
      var affiliate = utils.getAffiliateId();

      if (form.$valid) {
        var data = {
          shop: $scope.shop.id,
          dateFrom: $scope.trip.startDate || moment($scope.trip.from).format('YYYY-MM-DDThh:mm'),
          dateTo: $scope.trip.endDate || moment($scope.trip.to).format('YYYY-MM-DDThh:mm'),
          items: $scope.items,
          roomParams: $scope.roomParams,
          isResort: $scope.resortCheckout,
        };

        angular.extend(vm.preOrder, data);

        vm.loader = true;

        if (affiliate) {
          vm.preOrder.affiliateId = affiliate.aid;
          vm.preOrder.affiliateCampaign = affiliate.cid;
        }

        checkoutService.blockSpot(vm.preOrder).then(function (data) {
          if (vm.preOrder.createAccount) {
            vm.preOrder.password2 = vm.preOrder.password;
            vm.preOrder.orderId = data.id;

            $rootScope.toState = $scope.pageUrl;

            Auth.registration(vm.preOrder).then(finish);
          } else {
            finish();
          }

          function finish() {
            $.fancybox.close();
            $rootScope.showNotify(gettextCatalog.getString('Thanks! Your request was successfully submitted'));
            GTM.event(['booking_enquiry_reserve_spot_completed', 'checkout_block_spot']);
          }
        }).finally(function () {
          vm.loader = false;
        });
      }
    }
  });
})();
